import { Component, ElementRef, Inject, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EllipsisPipe } from 'src/app/pipes/ellipsis/ellipsis.pipe';
import { SelectObjectComponent } from '../select-object/select-object.component';
import { DeleteItemComponent } from '../../delete-item/delete-item.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { CourseService } from 'src/app/services/course/course.service';
import { Subscription } from 'rxjs';
import { AddObjectComponent } from '../add-object/add-object.component';
import * as object_settings from '../courses/courses-data/object_settings.json';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { escapeLabel } from '@swimlane/ngx-charts';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { Router } from '@angular/router';
import { AddExamComponent } from '../add-exam/add-exam.component';
import { C } from '@fullcalendar/core/internal-common';
import { GlobalService } from 'src/app/services/global/global.service';
import { CookieService } from 'ngx-cookie-service';
import { E } from '@angular/cdk/keycodes';
import { ViewCoursePreviewComponent } from '../view-course-preview/view-course-preview.component';
import { MatRadioChange } from '@angular/material/radio';
import { NgxSpinnerService } from 'ngx-spinner';
// Component logics
//1.Basically this component has two types of courses "scratch" & "template" we have three different array one for each course and third one is blank array (courseArrName)
//in which the selected courses array value will be populated on the basis of selected course
//2.Have three different booleans to manage the view on the screen as we have threee different views on screen 1.scratch course 2.template course 3. Course Detail
//3.While adding the object data is been sent from "Add Object" to "Add Course" hence is passing from 1st component to 3rd component.
@Component({
  selector: 'app-add-course',
  templateUrl: './add-course.component.html',
  styleUrls: ['./add-course.component.scss'],
})
export class AddCourseComponent {
  title = 'Editable Title';
  public isAddExam: boolean = false;
  public contentDetails: any[] = (object_settings as any).default;
  isDropped: boolean = false;
  templateCourseArr: any[] = [];
  public adminTemplateArr:any[]=[];
  public companyTemplateArr:any[]=[];

  scratchCourseArr: any[] = [
    {
      s_tit: "",
      s_i: "",
      sub_s: []
    }
  ]
  panelOpenState = false;
  public selectedCourse: any;
  private sharedDataSubscription!: Subscription;
  private addObjectId!: number
  public scratchForm!: FormGroup;
  public courseDetail!: FormGroup;
  public courseError!: string;
  public certificateType: string = 'never';

  public courseType: string = 'scratch';
  public courseArrName: any;
  public isBothTab: boolean = true;
  public isCourseSave: boolean = false;
  public isCourseNameCompleted: boolean = false;
  private animationConfig: {} = { enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", }
  public isEditCourse: boolean = false;
  public departmentArr: any[] = [];
  public viewCourse: any;
  public courseId: any;
  public isSpinnerLoading: boolean = false;
  public isViewCourse: boolean = false;
  public isAdmin: boolean = false;
  public selectedTheme: any;
  // @ViewChild('myInput') myInputElement!: ElementRef;
  @ViewChildren('myInput') myInputElement!: QueryList<ElementRef>;
  public imageURL: string = GlobalService.imageURL;
  public isThemeChange: boolean = true;
  public files: File[] = [];
  public imagePath;
  public themeUrl:string=''
  constructor(public dialog: MatDialog, private courseService: CourseService, private fb: FormBuilder, private appService: AppService,
    private commonService: CommonService, private router: Router, public cookieService: CookieService,private spinner:NgxSpinnerService,
    public dialogRef: MatDialogRef<AddCourseComponent>, @Inject(MAT_DIALOG_DATA) public dialogData: any) { }

  ngOnInit(): void {
    this.onInitializeForms();


    // method to add data which is added using addobject 
  
    this.courseArrName = this.scratchCourseArr;
    // when the component is opened as edit course then below logic
    if (this.isEditCourse) {
      // this.scratchForm.get('courseName')?.setValue('test Course')
      // this.isCourseNameCompleted = true;
    };
    if (this.dialogData) {
      if (this.dialogData["data"]["isViewCourse"]) {
        this.isViewCourse = true
        this.isCourseSave = true;
        this.isCourseNameCompleted = true;
      }
      else {
        this.isEditCourse = true;
      }
      // this.isEditCourse=true;
      this.courseId = this.dialogData["data"]["c_i"];
      this.onViewCourseAPI()
    }
    this.checkUserType()
    // this.getAllTemplate()
    if( this.appService.getSessionData('theme')){
      this.appService.removeSessionData('theme')
    }
    if(!this.isEditCourse && !this.isViewCourse){
      this.getAllTemplate()
    }
    this.selectedCourse = this.templateCourseArr[0];
    this.sharedDataSubscription = this.courseService.sharedData$.subscribe(data => {
      if (this.courseType == 'template') {
        this.selectedCourse[this.addObjectId].sub_s.push({ ...data });
      }
      else {
        if (!this.scratchCourseArr[this.addObjectId].hasOwnProperty("sub_s")) {
          this.scratchCourseArr[this.addObjectId]["sub_s"] = []
        }
        const examIndex = this.scratchCourseArr[this.addObjectId].sub_s.findIndex(item => item.type === "exam");
        if (examIndex !== -1) {
          // "exam" exists, remove it temporarily
          const examObject = this.scratchCourseArr[this.addObjectId].sub_s.splice(examIndex, 1)[0];
          // Apply your modifications to the data array
          // For example, let's add the new object
          this.scratchCourseArr[this.addObjectId].sub_s.push({ ...data })

          this.scratchCourseArr[this.addObjectId].sub_s.push({ ...examObject })
        } else {
          // "exam" doesn't exist, just apply your modifications
          this.scratchCourseArr[this.addObjectId].sub_s.push({ ...data })
        }

      }
    });
    setTimeout(()=>{
      this.getDepartmentList()},200)
  }
  checkUserType() {
    if (this.cookieService.get('user_id') && window.location.href.includes('cdashboard')) {
      // whenever admin user set the token of admin 
      this.appService.storeData('training-portal.admin-authToken', this.cookieService.get('user_id'));
      this.appService.storeSessionData('isAdmin', JSON.stringify(true));
      this.isAdmin = true;
    }
    else {
      this.isAdmin = false;
    }
  }
  // all reactive forms are initialized over here.
  onInitializeForms() {
    this.scratchForm = this.fb.group({
      'courseName': ['', Validators.required],
      "img": "",
      "c_type":['scratch']
    })
    this.courseDetail = this.fb.group({
      is_info: [1, Validators.required],
      m_c_g: [0, Validators.required],
      dep: ['', Validators.required],
      desc: ['', Validators.required],
      c_msg: ['', Validators.required],
      c_et: ['',Validators.min(1)],
      e_t: ['final'],
      qualify_marks: [],
      pr: ['0'],
    })
    this.formValidtaion()
  }
  formValidtaion() {
    if (this.isAdmin) {
      this.courseDetail.get('pr')?.setValidators([Validators.required,Validators.min(0.01)]);
    } else {
      this.courseDetail.get('pr')?.clearValidators();
    }
    this.courseDetail.get('pr')?.updateValueAndValidity();
  
    if (this.certificateType === "expire") {
      this.courseDetail.get('c_et')?.setValidators([Validators.required]);
    } else {
      this.courseDetail.get('c_et')?.clearValidators();
    }
    this.courseDetail.get('c_et')?.updateValueAndValidity();
  }
  
 
  onCourseType(event:MatRadioChange) {
    // this.courseDetail.reset();
    this.courseError = ""
    this.courseType = event.value;
    if (this.courseType == 'template') {
        this.getTemplateDetail(this.templateCourseArr[0])
    }
    else {
      this.courseArrName = this.scratchCourseArr;
    }
  }
  expandTab(tab: any) {
    tab.classList.add('show-tab');
  }
  onCourseTitle(course: any) {
    this.getTemplateDetail(course)

  }
  onSelectTemplate(item: any) {
    if (item.t_i != this.selectedCourse[0]["t_i"]) {
       this.getTemplateDetail(item)
    }
  }
  onAddObject(id: number) {
    this.addObjectId = id;
    let examDisabled;
    let isExamAllowed; //if not info course and no final exam then only show exam option if no previous sub section then alert user to add them first to add exam 
    // any changes over here should be done in edit also
    // if it is informational course don't allow to add section exams alos
    if (this.courseDetail.get('is_info')?.value == 1 || this.courseDetail.get('e_t')?.value == 'final') {
      examDisabled = true;
      isExamAllowed=false
    }
    else {
      isExamAllowed=true;
      if (this.courseArrName[id].sub_s && this.courseArrName[id].sub_s.length > 0) {
        examDisabled=false
        // the below was used as there was condition according to which if one section exam is created then second one was not allowed 
        // examDisabled = this.courseArrName[id].sub_s.some(item => item.type === "exam");
      }
      else {
        examDisabled = true;
      }
    }
    // let data={isExamAdded:false}
    let data = {
      isExamDisabled: examDisabled,
      themeDetail: this.selectedTheme,
      isExamAllowed:isExamAllowed,
    }
    const dialogRef = this.dialog.open(SelectObjectComponent, Object.assign({ data: data }, this.animationConfig));
    dialogRef.afterClosed().subscribe(result => {
    });
  }
  onDeleteCourse(id: number, sub_id: number) {
    const dialogRef = this.dialog.open(DeleteItemComponent, Object.assign({ data: { api_type: "delete_content" } }, this.animationConfig));
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result["delete_content"] == true) {
          this.courseArrName[id].sub_s.splice(sub_id, 1)
        }
      }
    });
  }
  onCopyCourse(id: number, item: Object) {
    const copiedItem = { ...item };
    copiedItem["s_si"] = ""
    // this.courseArrName[id].sub_section.push(copiedItem)
    const examIndex = this.courseArrName[id].sub_s.findIndex(item => item.type === "exam");
    if (examIndex !== -1) {
      // "exam" exists, remove it temporarily
      const examObject = this.courseArrName[id].sub_s.splice(examIndex, 1)[0];
      // Apply your modifications to the data array
      // For example, let's add the new object
      this.courseArrName[id].sub_s.push(copiedItem)
      this.courseArrName[id].sub_s.push({ ...examObject })
    } else {
      // "exam" doesn't exist, just apply your modifications
      this.courseArrName[id].sub_s.push(copiedItem)
    }
  }
  // this function used for subsection drag and drop
  drop(id: number, event: CdkDragDrop<string[]>) {
    // if the object added is exam then it should be always last item and it can't be dragged or dropped.
    if ((event.currentIndex != this.courseArrName[id].sub_s.length - 1)) {
      moveItemInArray(this.courseArrName[id].sub_s, event.previousIndex, event.currentIndex)
    }
  }
  // this function used for main section drag and drop
  mainDrop(event: CdkDragDrop<string[]>) {
    // moveItemInArray(this.selectedCourse.sections, event.previousIndex, event.currentIndex);
    moveItemInArray(this.courseArrName, event.previousIndex, event.currentIndex);
  }
  isControlHasError(controlName: string, validationType: string,): boolean {
    return this.appService.isControlHasError(this.courseDetail, controlName, validationType)
  }
  onEditItem(id: number, sub_id: number, item: any) {
    let contentType = this.courseArrName[id].sub_s[sub_id].type
    // check content Type if it is exam then open edit exam modal or else normal object modal ?
    if (contentType != 'exam') {
      let newArr: any[] = []
      var input_type = this.contentDetails.find(i => i.type == item.type)
      item["input_t"] = input_type["input_t"]
      newArr.push(item);
      const dialogRef = this.dialog.open(AddObjectComponent, Object.assign({
        width: this.getDialogWidth(),
        height: "90%", minWidth:'280px',
        maxWidth: "100vw", data: { type: item["type"], selectedObject: newArr, edit: true }
      }, this.animationConfig));
      dialogRef.afterClosed().subscribe(result => {
        if (result && result["data_item"]) {
          this.courseArrName[id].sub_s[sub_id] = result["data_item"]
        }
      });
    }
    else {
      this.onManageExam(item)
    }
  }
  onManageExam(item: any) {
    let data = {
      c_i: this.courseId,
      exam_type: "s_e",
      e_i: item.e_i
    }
    const dialogRef = this.dialog.open(AddExamComponent, {
      width: '96%',
      height: '93%',
      maxWidth: '100vw',
      maxHeight: "800px",
      panelClass: 'addCourseModal',
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms",
      data: data
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
  getDialogWidth(): string {
    // Adjust the breakpoints and corresponding heights based on your requirements
    if (window.innerWidth > 1400) {
      return '60%'; // Set the height for small screens
    } else if (window.innerWidth > 1140 && window.innerWidth < 1400) {
      return '80%'; // Set the height for medium screens
    } else if (window.innerWidth > 768 && window.innerWidth < 1140) {
      return '90%'; // Set the height for medium screens
    } else {
      return '90%'; // Set the height for large screens
    }
  }
  onEditSection(event: any, item: any) {
    const index = this.courseArrName.indexOf(item);
    const inputElement = this.myInputElement.toArray()[index];
    if (inputElement) {
      inputElement.nativeElement?.focus();
    }
    event.stopPropagation();
  }
  onCopySection(event: Event, item: Object) {
    event.stopPropagation();
    const copiedItem = { ...item };
    copiedItem["s_i"] = ""
    copiedItem["sub_s"].map(i => {
      if (i["s_i"]) {
        i["s_i"] = ""
      }
      if (i["s_si"]) {
        i["s_si"] = ""
      }
    })
    this.courseArrName.push(JSON.parse(JSON.stringify(copiedItem)));
  }
  onDeleteSection(event: Event, id: number) {
    event.stopPropagation();
    // this.courseArrName.splice(id, 1);
    const dialogRef = this.dialog.open(DeleteItemComponent, Object.assign({ data: { api_type: "delete_content" } }, this.animationConfig));
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result["delete_content"] == true) {
          this.courseArrName.splice(id, 1);
        }
      }
    });
  }
  onAddSection() {
    let obj = {
      s_tit: "",
      s_i: "",
      sub_s: []
    }
    this.courseArrName.push(obj)
  }
  onAddSectionScratch() {
    let obj = {
      s_tit: "",
      s_i: "",
      sub_s: []
    }
    this.scratchCourseArr.push(obj)
  }
  onTitle(index: any, event: any) {
    this.selectedCourse.sections[index]["title"] = event.target.value;
  }
  onClose() {
    // this.dialog.closeAll()
    this.dialogRef.close()
  }
  onCertificateType(event: MatRadioChange) {
    if(event.value==0){
      this.certificateType="never"
    }
    else{
      this.certificateType="expire"
    }
    this.formValidtaion()
  }
  onCourseDetailSubmit() {
    let qualifyPerError = this.onQualifyMark()
    if (!this.courseDetail.valid || qualifyPerError) {
      this.courseDetail.markAllAsTouched()
    }
    else {
      setTimeout(()=>{
        this.isCourseSave = true;
        if (this.isEditCourse) {
          this.isBothTab = false;
        }
      },500)
     
    }
  }
  get getCourseDetailControl() {
    return this.courseDetail.controls;
  }
  onSave(type: string) {
    this.courseError = ""
    //  this is done to know which type of validation to show to user
    if (this.courseArrName.length > 0) {
      this.courseArrName.forEach((element: any) => {
        if (element.s_tit == '') {
          this.courseError = "Please add section title and atleast one object in it to save course"
        }
        else if (element.sub_s.length == 0) {
          this.courseError = "Please add at least one object in the section to save course"
        }
        else if (element.sub_s.length == 1 && (element.sub_s[0]['type'] == 'exam')) {
          this.courseError = "Please add at least one object in the section as you cann't create a section with only exam"
        }
        else {
        }
      });
      const doEmptyAction = this.courseArrName.every((o: any) =>
        (((o.s_tit != '') && (o.sub_s.length != 0)) || (o.sub_s.length == 1 && o.sub_s[0]['type'] == 'exam')))
      // don't allow to proceed if a section contains only exam and not any other section
      const isExamError = this.courseArrName.some((o: any) => (o.sub_s.length == 1 && o.sub_s[0]['type'] == 'exam'))
      if (doEmptyAction == true && !isExamError) {
        this.isBothTab = false;
        this.isCourseSave = true;
        // alert()
        // adding API Call 
         this.onSaveCourse(type)
      }
    }
    else {
      this.courseError = "Please add section title and atleast one object in it to save course"
    }
  }
  onSaveCourse(saveType: string) {
    let formData: any = new FormData();
    // have set index over here as it is needed for API
    this.courseArrName.map((item: any) => { item["sub_s"].map((value: any, i: any) => { value["index"] = i }) })
    let newObj: any = {
      "login_type": "company",
      "ins": "1",
      "pr": this.courseDetail.get('pr')?.value,
      "acc": "0",
    }
    // if (this.courseType == "scratch") {
    newObj["tit"] = this.scratchForm.get('courseName')?.value
    if (this.courseType == "scratch") {
      newObj["t_tit"] = this.scratchForm.get('courseName')?.value
    }
    if (this.courseType == "template") {
      let newTempArr=JSON.parse(JSON.stringify(this.templateCourseArr))
      let selTemp= newTempArr.find(i=>i.t_i==this.selectedCourse[0]["t_i"])
      newObj["t_tit"] =selTemp["t_tit"]
    }
    // }
    // else {
    //   newObj["title"] = this.selectedCourse.course_title
    // }
    newObj = Object.assign(newObj, this.courseDetail.value)
    newObj["img"] = this.scratchForm.get('img')?.value
    newObj["sections"] = this.courseArrName;
    newObj["th_i"] =0;
    if(this.selectedTheme){
     newObj["th_i"] = this.selectedTheme.id;
    }   
    newObj["instructor"] = 1;
    formData = this.commonService.convertToFormData(newObj);
    // formData.append("pr",1);
    if (this.isEditCourse) {
      formData.append('c_i', this.courseId)
      formData.append('is_e', this.dialogData["data"]["is_e"])
      formData.append('is_build', this.dialogData["data"]["is_build"])
      // if(this.courseT)
      if (saveType == "course") {
        this.onEditCourseAPI(formData)
      }
      else {
        formData.append('t_i', this.selectedCourse[0].t_i)
        this.onEditTemplateAPI(formData)
      }
      // this.onEditCourseAPI(formData)
    }
    else {
      // here type : course means "Save button pressed" & for else it will be "Template"
      if (saveType == 'course') {
        this.onSaveCourseAPI(formData);
      }
      else {
        if (this.courseType == 'scratch') {
          this.onSaveAsTemplateCourseAPI(formData)
        }
        else {
          formData.append('t_i', this.selectedCourse[0].t_i)
          this.onEditTemplateAPI(formData)
        }
      }
    }
  }
  onConfirm() {
    this.isCourseNameCompleted = true;
    this.isBothTab = false;
  }
  onInput(event: any) {
  }
  onBack(value: string) {
    if (value == 'course-detail') {
      this.isCourseNameCompleted = false;
      this.isBothTab = true;
    }
    else {
      this.isCourseSave = false
    }
  }
  onTemplateTitleChange(event) {
    this.selectedCourse[0]["t_tit"] = event.target.value;
  }
  onSearchTemp(event:any){
    const inputValue = event.target.value;
    let newTemplateArr:any[]=[...this.templateCourseArr]
    if(inputValue){
      if(this.companyTemplateArr.length >0)
        this.companyTemplateArr = this.companyTemplateArr.filter(item => item.t_tit && item.t_tit.toLowerCase().includes(inputValue.toLowerCase()));
      if(this.adminTemplateArr.length >0)
        this.adminTemplateArr = this.adminTemplateArr.filter(item => item.t_tit && item.t_tit.toLowerCase().includes(inputValue.toLowerCase()));
    } else {
      if(newTemplateArr.length > 0) {
        this.companyTemplateArr = newTemplateArr.filter(i => i.t == 'c');
        this.adminTemplateArr = newTemplateArr.filter(i => i.t == 'a');
      }       
    }
    return this.adminTemplateArr, this.companyTemplateArr;    
  }
  getAllTemplate() {
    this.courseService.getAllTemplate().subscribe({
      next: (success: any) => { 
            
        this.adminTemplateArr=[...success.data.com_c,]
        this.companyTemplateArr=[...success.data.oth_c]
        this.templateCourseArr = [...success.data.com_c, ...success.data.oth_c]
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  getTemplateDetail(item: any) {
    let data = {
      t_i: item.t_i,
      t: item.t
    }
    this.spinner.show()
    this.courseService.getTemplateSection(data).subscribe({
      next: (success: any) => {
        if(success.status==200 && success.data.length >0){
           this.spinner.hide()
           this.selectedCourse = success.data;
           this.courseArrName = success.data;
           this.themeUrl=success.tem_img
        }        
      },
      error: (error: any) => {
        this.spinner.hide()
        this.commonService.handleError(error);
      },
    });
  }
  onSaveCourseAPI(formData: any) {
    this.spinner.show()
    this.courseService.saveCourse(formData).subscribe({
      next: (success: any) => {
        this.spinner.hide()
        this.isSpinnerLoading = false;
        if (success.status == 200) {
          this.appService.showToastMessage('success', success.msg)
          this.dialogRef.close({ content_edited: true });
        }
      },
      error: (error: any) => {
        this.spinner.hide()
        this.isSpinnerLoading = false;
        this.commonService.handleError(error);
      },
    })
  }
  onSaveAsTemplateCourseAPI(formData: any) {
    this.isSpinnerLoading = true;
    this.spinner.show()
    this.courseService.saveTemplateCourse(formData).subscribe({
      next: (success: any) => {
        this.isSpinnerLoading = false;
        this.spinner.hide()
        if (success.status == 200) {
          this.appService.showToastMessage('success', success.msg)
        }
      },
      error: (error: any) => {
        this.spinner.hide()
        this.isSpinnerLoading = false;
        this.commonService.handleError(error);
      },
    })
  }
  onEditTemplateAPI(data) {
    this.spinner.show()
    this.courseService.editTemplate(data).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        this.isSpinnerLoading = false;
        if (success.status == 200) {
          this.appService.showToastMessage('success', success.msg)
        }
      },
      error: (error: any) => {
        this.spinner.hide()
        this.isSpinnerLoading = false;
        this.commonService.handleError(error);
      },
    });
  }
  onDeleteTemplateAPI(event, item) {
    event.stopPropagation();
    let data = {
      t_i: item.t_i,
      t: item.t
    }
    this.courseService.deleteTemplate(data).subscribe({
      next: (success: any) => {
        this.isSpinnerLoading = false;
        if (success.status == 200) {
          this.appService.showToastMessage('success', success.msg)
          this.getAllTemplate()
        }
      },
      error: (error: any) => {
        this.isSpinnerLoading = false;
        this.commonService.handleError(error);
      },
    });
  }
  onViewCourseAPI() {
    let obj={
      c_i:this.courseId,
      t:this.dialogData.data.t
    }
    this.spinner.show()
    this.courseService.getCourseInfo(obj).subscribe({next:(data: any) => {
      this.spinner.hide()
      if (data.status == 200) {
        let courseData = data["data"];
        this.scratchForm.get('courseName')?.setValue(courseData.tit)
        // this.isCourseNameCompleted = true;
        this.courseArrName = [];
        this.scratchCourseArr = courseData.sections;
        this.courseArrName = courseData.sections;
        if (courseData["img"]) {
          this.scratchForm.get('img')?.setValue(courseData["img"])
        }
        this.themeUrl=courseData["tem_img"]
        for (let [key, value] of Object.entries(this.courseDetail.value)) {
          for (let [fkey, fvalue] of Object.entries(courseData)) {
            if (key == fkey) {
              this.courseDetail.get(fkey)?.setValue(fvalue);
            }
            if(fkey=='d_i'){
              this.courseDetail.get('dep')?.setValue(fvalue);
            }
            if(fkey=="c_et" ){
              if(fvalue==0 || fvalue==''){
                this.certificateType="never"
              }
              else{
                this.certificateType="expire"
              }
              this.courseDetail.get('c_et')?.setValue(fvalue);
            }
          }
        }
        this.isBothTab = false;
      }
      
    },
    error:(error)=>{
      this.spinner.hide()
    }
  })
  }
  onEditCourseAPI(data: any) {
    this.spinner.show()
    this.courseService.editCourse(data).subscribe({next: (success: any) => {
      this.spinner.hide()
      if (success["status"] == 200) {
        this.appService.showToastMessage('success', success.msg)
        this.dialogRef.close({ content_edited: true });

      }
    },error:(error:any)=>{
      this.commonService.handleError(error);
      this.spinner.hide()
    }    
    })
  }
  getDepartmentList() {
    this.departmentArr = []
    this.courseService.getDepartmentList().subscribe((data: any) => {
      if (data["status"] == 200) {
        this.departmentArr = data["data"];
      }
    })
  }
  onSelect(event) {
    this.files = [];
    this.files.push(...event.addedFiles);
   this.onImageChange()
  }
  onImageChange() {
    let formData = new FormData();
    formData.append('ex_file', '')
    formData.append('type', 'exam')
    formData.append('obj_file', this.files[0])
     this.isSpinnerLoading = true;
    this.courseService.uploadFile(formData).subscribe((response: any) => {
      if (response.status == 200) {
         this.scratchForm.get('img')?.setValue(response.msg)
       this.isSpinnerLoading = false;
      }
      else{
        this.isSpinnerLoading=false;
      }
    })
  }
  onDeleteImage() {
    let formData = new FormData();
    formData.append('ex_file', this.scratchForm.get('img')?.value)
    formData.append('type', 'exam')
    formData.append('obj_file', '')
    this.courseService.uploadFile(formData).subscribe((response: any) => {
      if (response["status"] == 200) {
         this.scratchForm.get('img')?.setValue('');
      }
    })
  }
  onQualifyMark() {
    let qualify_mark = this.courseDetail.get('qualify_marks')?.value;
    if (this.courseDetail.get('e_t ')?.value == 'average' && (qualify_mark == '' || qualify_mark == null || qualify_mark == undefined)) {
      return true;
    }
    else {
      if (this.courseDetail.get('e_t ')?.value == 'average' && (qualify_mark < 1 || qualify_mark > 100)) {
        return true
      }
      else {
        return false
      }
    }
  }
  setTheme(img) {
    this.appService.storeSessionData('theme', img)
  }
  onCourseOverview(value) {
    if (this.courseArrName.length > 0) {
      const hasTitleSubsection = this.courseArrName.some((element: any) => (element.sub_s.length > 0) && (element.s_tit != ''))
      if (hasTitleSubsection) {
        if(value=='overview'){
          this.onChangeTheme('overview')
        }
        else{
          this.onChangeTheme('theme')
        }
      }
      else {
        this.appService.showToastMessage('warning', "Please add section and at least one sub section to view this")
      }
    }
    else {
      this.appService.showToastMessage('warning', "Please add section and at least one sub section to view this")
    }
  }
  onChangeTheme(value) {
   let cData: {}
    cData= JSON.parse(JSON.stringify(this.courseArrName));
    cData["parentMenu"] = "AddCourse"
    if (value == 'theme') {
      cData["isThemePreview"] = true;
    }
     if( this.appService.getSessionData('theme')){
      cData['tem_img']=this.appService.getSessionData('theme')
    }
    else if(this.themeUrl!=''){
      cData['tem_img']=this.themeUrl
    }
    const dialogRef = this.dialog.open(ViewCoursePreviewComponent, {
      width: '96%',
      height: '94%',
      // maxHeight: "800px",
      maxWidth: '100vw',
      panelClass: 'addCourseModal',
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms",
      data: cData
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.selectedTheme = result.data
        this.setTheme(result.data.tem_img)
      }
    });
  }
  ngOnDestroy(): void {
    this.sharedDataSubscription.unsubscribe();
    this.appService.removeSessionData('theme')
  }
}
